import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CataloghiRoutingModule } from './cataloghi-routing.module';
import { CataloghiComponent } from './cataloghi.component';
import { RouterModule } from '@angular/router';
//import { MyCustomMaterialModule } from '../shared/my-custom-material/my-custom-material.module';
import { FormsModule } from '@angular/forms';
import { CataloghiCreateComponent } from './cataloghi-create/cataloghi-create.component';
import { CataloghiComboComponent } from './cataloghi-combo/cataloghi-combo.component';
import { CataloghiDetailsComponent } from './cataloghi-details/cataloghi-details.component';
import { CataloghiListComponent } from './cataloghi-list/cataloghi-list.component';
import { CataloghiEditComponent } from './cataloghi-edit/cataloghi-edit.component';
import { MyCustomMaterialModule } from 'san-common';

@NgModule({
  imports: [
    CommonModule,
      CataloghiRoutingModule,
      RouterModule,
     MyCustomMaterialModule,
      FormsModule

  ],
  declarations: [
    CataloghiComponent,
    CataloghiCreateComponent,
    CataloghiComboComponent,
    CataloghiDetailsComponent,
    CataloghiListComponent,
    CataloghiEditComponent
  ],
  exports: [
    CataloghiComponent,CataloghiCreateComponent,
    CataloghiComboComponent,
    CataloghiDetailsComponent,CataloghiListComponent,
    CataloghiEditComponent
  ],
     providers: [
    ]
})
export class CataloghiModule { }
